<template>
  <div class="press-releases">
    <div class="press-releases__filter">
      <div class="press-releases__group">
        <label
          for="press-filter-select"
          class="press-releases__label"
        >
          {{ i18n.categoryTitle }}
        </label>

        <select
          id="press-filter-select"
          v-model="selectedCategory"
          class="press-releases__select"
          @change="doSearch()"
        >
          <option
            value
            selected
          >
            {{ i18n.categoryLabel }}
          </option>
          <option
            v-for="(category, index) in categories"
            :key="index"
            :value="category"
          >
            {{ category }}
          </option>
        </select>
      </div>

      <div class="press-releases__group">
        <label
          for="press-filter-input"
          class="press-releases__label"
        >
          {{ i18n.filterTitle }}
        </label>
        <input
          id="press-filter-input"
          v-model="query"
          type="text"
          class="press-releases__input"
          @keyup="keyPressSearch()"
        >
      </div>

      <c-button
        use-custom-button="secondary"
        @click="doSearch(), pushGTM()"
      >
        {{ i18n.searchButtonText }}
      </c-button>
    </div>

    <ul class="press-releases__results">
      <li
        v-for="(item, index) in (state.results || [])"
        :key="index"
      >
        <press-item
          :link="item.link"
          :categories="item.categories"
          @click="pushPressItem(item.title, item.categories, item.date, item.link)"
        >
          <template #title>
            {{ item.title }}
          </template>
          <template #text>
            {{ item.text }}
          </template>
          <template #date>
            {{ item.date }}
          </template>
        </press-item>
      </li>
    </ul>

    <div v-if="state.results.length === 0">
      <slot name="no-press-found" />
    </div>

    <div class="press-releases__paginator">
      <paginator
        :current="current"
        :i18n="i18n"
        :total="state.total"
        :limit="limit"
        scroll-to="press-releases"
        @paginate="handlePagination"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Paginator from '@molecules/paginator/paginator.vue'
import CButton from '@atoms/button/button.vue'
import isOutbound from '@tagging/isOutbound.js'
import PressItem from './press-item.vue'
import API from './api'

export default {
  name: 'press',
  components: {
    paginator: Paginator,
    CButton,
    PressItem,
  },
  props: {
    i18n: {
      type: Object,
      default() {
        return {
          paginatorPrevious: 'Previous',
          paginatorNext: 'Next',
        }
      },
    },
    limit: {
      type: Number,
      default: 4,
    },
    api: {
      type: String,
    },
    categories: {
      type: Array,
    }
  },
  data() {
    return {
      timeout: null,
      query: '',
      selectedCategory: '',
    }
  },
  computed: {
    ...mapState({
      state: (state) => state.press,
    }),
    current: {
      get() {
        return this.$store.state.press.current
      },
      set(current) {
        this.$store.commit('press/paginate', current)
      },
    }
  },
  created() {
    Object.assign(API.options, {
      search: this.api,
    })
  },
  mounted() {
    this.doSearch()
  },
  methods: {
    doSearch(event) {
      const request = {
        query: this.query,
        category: this.selectedCategory
      }
      this.$store.commit('press/filter', request)

      if (event) {
        event.preventDefault()
      }
    },
    keyPressSearch() {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.doSearch()
      }, 500)
    },
    handlePagination(page) {
      this.current = page
    },
    pushGTM() {
      window.dataLayer.push({
        event: 'search',
        section: 'press-releases',
        name: this.query || '',
        filtered: !!this.selectedCategory,
        category: this.selectedCategory || '',
        quantity: this.state.numberOfResults,
      })
    },
    pushPressItem(title, categories, date, link) {
      window.dataLayer.push({
        event: 'article_click',
        label: title || '',
        category: categories ? categories.join(', ') : '',
        date: date || '',
        outbound: isOutbound(link),
        filtered: !!this.selectedCategory,
        url: link || ''
      })
    }
  },
}
</script>
